/* Cart drawer nativo Amba Black — estado via Cart AJAX API (/cart.js). */
(function () {
  'use strict';

  var drawer, overlay, els = {};
  var state = { cart: null, recsProductId: null, busy: false };
  var nativeFetch = window.fetch.bind(window);

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getJSON(url) {
    return nativeFetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function postJSON(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  /* ---------- render ---------- */

  function renderShipbar(cart) {
    var threshold = parseInt(drawer.getAttribute('data-threshold'), 10) || 12900;
    var total = cart.total_price;
    var falta = threshold - total;
    var fill = Math.min(100, Math.round((total / threshold) * 100));
    var bar = document.getElementById('acd-shipbar');
    els.shipbarFill.style.width = fill + '%';
    if (bar) bar.classList.remove('acd-ship-close', 'acd-ship-done');
    if (cart.item_count === 0) {
      els.shipbarText.innerHTML = 'Frete gr&aacute;tis em compras acima de <b>' + money(threshold) + '</b>';
    } else if (falta <= 0) {
      if (bar) bar.classList.add('acd-ship-done');
      els.shipbarText.innerHTML = 'Voc&ecirc; ganhou <b>frete gr&aacute;tis</b>!';
    } else if (falta <= 4000) {
      if (bar) bar.classList.add('acd-ship-close');
      els.shipbarText.innerHTML = 'Falta pouco! Mais <b>' + money(falta) + '</b> e o frete &eacute; por nossa conta';
    } else {
      els.shipbarText.innerHTML = 'Faltam <b>' + money(falta) + '</b> para o <b>frete gr&aacute;tis</b>';
    }
  }

  function itemHTML(item) {
    var img = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_160x$1$2') : '';
    var meta = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var price = '<span>' + money(item.final_line_price) + '</span>';
    if (item.original_line_price > item.final_line_price) {
      price = '<s>' + money(item.original_line_price) + '</s><span>' + money(item.final_line_price) + '</span>';
    }
    return '<div class="acd-item" data-key="' + esc(item.key) + '">' +
      '<a class="acd-item-img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') + '</a>' +
      '<div class="acd-item-info">' +
        '<a class="acd-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        (meta ? '<p class="acd-item-meta">' + esc(meta) + '</p>' : '<p class="acd-item-meta"></p>') +
        '<div class="acd-item-bottom">' +
          '<div class="acd-qty">' +
            '<button type="button" data-act="minus" aria-label="Diminuir quantidade">&minus;</button>' +
            '<input type="text" inputmode="numeric" value="' + item.quantity + '" aria-label="Quantidade">' +
            '<button type="button" data-act="plus" aria-label="Aumentar quantidade">+</button>' +
          '</div>' +
          '<div class="acd-item-price">' + price + '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="acd-item-remove" data-act="remove" aria-label="Remover item">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2m1 0v14a2 2 0 01-2 2H9a2 2 0 01-2-2V6"/></svg>' +
      '</button>' +
    '</div>';
  }

  function discountSync(cart) {
    var activeCode = (cart.discount_codes || []).filter(function (d) { return d.applicable; })[0];
    if (activeCode && cart.total_discount > 0) {
      els.discountCode.textContent = activeCode.code;
      els.discountValue.textContent = '−' + money(cart.total_discount);
      els.discountRow.hidden = false;
    } else {
      els.discountRow.hidden = true;
    }
  }

  function applyTotals(cart) {
    els.count.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    els.empty.hidden = cart.item_count !== 0;
    els.foot.hidden = cart.item_count === 0;
    els.accs.style.display = cart.item_count === 0 ? 'none' : '';
    els.subtotal.textContent = money(cart.items_subtotal_price);
    els.total.textContent = money(cart.total_price);
    discountSync(cart);
    renderShipbar(cart);
    document.querySelectorAll('.minicart-btn .bigcounter').forEach(function (b) {
      b.textContent = cart.item_count;
    });
  }

  function linePriceHTML(item) {
    var price = '<span>' + money(item.final_line_price) + '</span>';
    if (item.original_line_price > item.final_line_price) {
      price = '<s>' + money(item.original_line_price) + '</s>' + price;
    }
    return price;
  }

  function render() {
    var cart = state.cart;
    if (!cart) return;
    els.items.innerHTML = cart.items.map(itemHTML).join('');
    applyTotals(cart);
    if (els.note.value !== (cart.note || '') && document.activeElement !== els.note) {
      els.note.value = cart.note || '';
    }
    loadRecs();
  }

  /* mesma estrutura de linhas -> atualiza números no lugar (sem reconstruir DOM,
     sem piscar imagem); estrutura mudou -> render completo */
  function reconcile(cart) {
    var rows = els.items.querySelectorAll('.acd-item');
    var same = rows.length === cart.items.length;
    if (same) {
      for (var i = 0; i < cart.items.length; i++) {
        if (rows[i].getAttribute('data-key') !== cart.items[i].key) { same = false; break; }
      }
    }
    if (!same) { render(); return; }
    cart.items.forEach(function (it, idx) {
      var input = rows[idx].querySelector('.acd-qty input');
      if (input && document.activeElement !== input) input.value = it.quantity;
      rows[idx].querySelector('.acd-item-price').innerHTML = linePriceHTML(it);
    });
    applyTotals(cart);
    loadRecs();
  }

  function setCart(cart) {
    state.cart = cart;
    reconcile(cart);
    document.dispatchEvent(new CustomEvent('amba:cart', { detail: cart }));
  }

  function refresh(openAfter) {
    if (openAfter) open();
    return getJSON('/cart.js').then(function (cart) {
      state.cart = cart;
      render();
      document.dispatchEvent(new CustomEvent('amba:cart', { detail: cart }));
    }).catch(function () {});
  }

  /* ---------- cross-sell ---------- */

  function loadRecs() {
    var cart = state.cart;
    if (!drawer.classList.contains('is-open')) return;
    if (!cart || cart.item_count === 0) { els.recs.hidden = true; return; }
    var pid = cart.items[0].product_id;
    if (state.recsProductId === pid) return;
    state.recsProductId = pid;
    getJSON('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related').then(function (data) {
      var inCart = {};
      state.cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var recs = (data.products || []).filter(function (p) {
        return !inCart[p.id] && p.available;
      }).slice(0, 4);
      if (!recs.length) { els.recs.hidden = true; return; }
      els.recsRow.innerHTML = recs.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/, '_300x$1$2') : '';
        return '<div class="acd-rec">' +
          '<a href="' + esc(p.url) + '"><img class="acd-rec-img" src="' + esc(img) + '" alt="" loading="lazy" decoding="async"></a>' +
          '<a class="acd-rec-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="acd-rec-bottom">' +
            '<span class="acd-rec-price">' + money(p.price) + '</span>' +
            (v ? '<button type="button" class="acd-rec-add" data-variant="' + v.id + '" aria-label="Adicionar ' + esc(p.title) + '">+</button>' : '') +
          '</div>' +
        '</div>';
      }).join('');
      els.recs.hidden = false;
    }).catch(function () { els.recs.hidden = true; });
  }

  /* ---------- abrir/fechar ---------- */

  function open() {
    if (!state.cart) {
      els.items.innerHTML = '<p style="text-align:center;color:#999;font-size:13px;padding:24px 0">Carregando…</p>';
    }
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    document.documentElement.classList.add('acd-lock');
    els.close.focus({ preventScroll: true });
  }

  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('acd-lock');
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 340);
  }

  /* ---------- mutações ---------- */

  /* ---------- UI otimista: números mudam no clique, a rede confirma depois ---------- */

  var mutGen = 0;
  var maxPorKey = {}; /* teto de estoque aprendido nas respostas do servidor */

  function optimisticTotals() {
    var cart = state.cart;
    if (!cart) return;
    cart.item_count = cart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    cart.items_subtotal_price = cart.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    cart.total_price = Math.max(0, cart.items_subtotal_price - (cart.total_discount || 0));
    applyTotals(cart);
  }

  function optimisticQty(key, quantity) {
    var cart = state.cart;
    if (!cart) return quantity;
    var it = cart.items.filter(function (i) { return i.key === key; })[0];
    if (!it) return quantity;
    var row = els.items.querySelector('[data-key="' + key + '"]');
    var max = maxPorKey[key];
    if (max && quantity > max) {
      quantity = max;
      var meta = row && row.querySelector('.acd-item-meta');
      if (meta) {
        meta.textContent = 'Estoque máximo: ' + max + (max === 1 ? ' unidade' : ' unidades');
        meta.classList.add('acd-item-warn');
      }
    }
    it.quantity = quantity;
    it.final_line_price = (it.final_price || it.price) * quantity;
    it.original_line_price = (it.original_price || it.price) * quantity;
    if (row) row.querySelector('.acd-item-price').innerHTML = linePriceHTML(it);
    optimisticTotals();
    return quantity;
  }

  function optimisticRemove(key) {
    var cart = state.cart;
    if (!cart) return;
    cart.items = cart.items.filter(function (i) { return i.key !== key; });
    var row = els.items.querySelector('[data-key="' + key + '"]');
    if (row) {
      row.style.transition = 'opacity .18s ease, transform .18s ease';
      row.style.opacity = '0';
      row.style.transform = 'translateX(14px)';
      setTimeout(function () { if (row.parentNode) row.parentNode.removeChild(row); }, 180);
    }
    optimisticTotals();
  }

  function changeLine(key, quantity) {
    var g = ++mutGen;
    (function attempt(n) {
      /* a cotação de frete da PDP faz add/restore temporário no carrinho —
         se ela está mexendo agora, espera a vez (evita 409 Conflict) */
      if (window.__ambaQuoting && n < 10) {
        setTimeout(function () { if (g === mutGen) attempt(n + 1); }, 450);
        return;
      }
      postJSON('/cart/change.js', { id: key, quantity: quantity })
        .then(function (cart) {
          if (g !== mutGen) return; /* já tem mutação mais nova em voo — ela reconcilia */
          setCart(cart);
          var item = cart.items.filter(function (i) { return i.key === key; })[0];
          if (quantity > 0 && item && item.quantity < quantity) {
            maxPorKey[key] = item.quantity; /* aprende o teto: próximos cliques clampam local */
            var newRow = els.items.querySelector('[data-key="' + key + '"]');
            var meta = newRow && newRow.querySelector('.acd-item-meta');
            if (meta) {
              meta.textContent = 'Estoque máximo: ' + item.quantity + (item.quantity === 1 ? ' unidade' : ' unidades');
              meta.classList.add('acd-item-warn');
            }
          }
        })
        .catch(function (err) {
          if (g !== mutGen) return;
          var msg = String(err && err.message);
          if (n < 12 && /409/.test(msg)) {
            /* carrinho trancado por outra operação — tenta de novo, sem reverter a UI */
            setTimeout(function () { if (g === mutGen) attempt(n + 1); }, 400);
            return;
          }
          if (/422/.test(msg)) {
            /* estoque insuficiente: a Shopify JÁ ajustou a linha pro máximo e devolveu 422 —
               busca o estado real, aprende o teto e avisa o cliente */
            getJSON('/cart.js').then(function (cart) {
              if (g !== mutGen) return;
              setCart(cart);
              var item = cart.items.filter(function (i) { return i.key === key; })[0];
              if (item) {
                maxPorKey[key] = item.quantity;
                var row = els.items.querySelector('[data-key="' + key + '"]');
                var meta = row && row.querySelector('.acd-item-meta');
                if (meta) {
                  meta.textContent = 'Estoque máximo: ' + item.quantity + (item.quantity === 1 ? ' unidade' : ' unidades');
                  meta.classList.add('acd-item-warn');
                }
              }
            }).catch(function () { refresh(); });
            return;
          }
          refresh();
        });
    })(0);
  }

  function bindEvents() {
    els.close.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* ícone do carrinho no header abre o drawer — stopPropagation impede o
       mini-cart offcanvas legado do tema de abrir junto */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.minicart-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        refresh(true);
      }
    }, true);

    /* add-to-cart sem ajax do tema: intercepta o submit e vira ajax */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.querySelector('[name="return_to"]')) return; /* comprar agora → checkout direto */
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      nativeFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return refresh(true);
        })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);

    /* qty, remover — otimista no clique; cliques rápidos coalescem numa única chamada */
    var qtyTimers = {};
    function scheduleQty(row, key, target) {
      target = optimisticQty(key, target); /* clampa no teto de estoque conhecido */
      row.querySelector('.acd-qty input').value = target;
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () {
        delete qtyTimers[key];
        changeLine(key, target);
      }, 250);
    }
    function removeLine(key) {
      clearTimeout(qtyTimers[key]);
      delete qtyTimers[key];
      optimisticRemove(key);
      changeLine(key, 0);
    }
    els.items.addEventListener('click', function (e) {
      var act = e.target.closest && e.target.closest('[data-act]');
      if (!act) return;
      var row = act.closest('.acd-item');
      var key = row.getAttribute('data-key');
      var qty = parseInt(row.querySelector('.acd-qty input').value, 10) || 1;
      var a = act.getAttribute('data-act');
      if (a === 'plus') scheduleQty(row, key, qty + 1);
      else if (a === 'minus') {
        /* em qty 1 o menos NÃO remove — remoção só pela lixeira (fim do sumiço acidental) */
        if (qty <= 1) return;
        scheduleQty(row, key, qty - 1);
      }
      else if (a === 'remove') removeLine(key);
    });
    els.items.addEventListener('change', function (e) {
      if (!e.target.matches('.acd-qty input')) return;
      var row = e.target.closest('.acd-item');
      var key = row.getAttribute('data-key');
      var qty = parseInt(e.target.value, 10);
      scheduleQty(row, key, isNaN(qty) ? 1 : Math.max(1, qty));
    });

    /* cross-sell quick add */
    els.recsRow.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.acd-rec-add');
      if (!btn) return;
      btn.disabled = true;
      postJSON('/cart/add.js', { id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1 })
        .then(function () { state.recsProductId = null; return refresh(); })
        .catch(function () {})
        .then(function () { btn.disabled = false; });
    });

    /* observação */
    var noteTimer;
    els.note.addEventListener('input', function () {
      clearTimeout(noteTimer);
      var val = els.note.value;
      noteTimer = setTimeout(function () {
        postJSON('/cart/update.js', { note: val }).then(function () {
          els.noteStatus.textContent = 'Observação salva ✓';
          setTimeout(function () { els.noteStatus.textContent = ''; }, 2500);
        }).catch(function () {});
      }, 700);
    });

    /* cupom: aplica de verdade no carrinho via /cart/update.js e mostra o desconto */
    els.couponBtn.addEventListener('click', function () {
      var code = els.couponInput.value.trim();
      els.couponStatus.classList.remove('is-error');
      if (!code) {
        els.couponStatus.textContent = 'Digite o código do cupom.';
        els.couponStatus.classList.add('is-error');
        return;
      }
      els.couponBtn.disabled = true;
      postJSON('/cart/update.js', { discount: code })
        .then(function (cart) {
          var entry = (cart.discount_codes || []).filter(function (d) {
            return d.code.toUpperCase() === code.toUpperCase();
          })[0];
          if (entry && entry.applicable) {
            setCart(cart);
            els.couponStatus.textContent = cart.total_discount > 0
              ? 'Cupom aplicado ✓ Você economizou ' + money(cart.total_discount) + '.'
              : 'Cupom aplicado ✓ O benefício aparece no checkout.';
            els.couponInput.value = '';
          } else {
            els.couponStatus.textContent = 'Cupom inválido ou não aplicável a estes produtos.';
            els.couponStatus.classList.add('is-error');
            return postJSON('/cart/update.js', { discount: '' }).then(refresh, function () {});
          }
        })
        .catch(function () {
          els.couponStatus.textContent = 'Não foi possível aplicar agora. Tente no checkout.';
          els.couponStatus.classList.add('is-error');
        })
        .then(function () { els.couponBtn.disabled = false; });
    });

    /* remover cupom aplicado */
    els.discountRemove.addEventListener('click', function () {
      postJSON('/cart/update.js', { discount: '' })
        .then(function (cart) {
          setCart(cart);
          els.couponStatus.textContent = 'Cupom removido.';
          els.couponStatus.classList.remove('is-error');
        })
        .catch(function () { refresh(); });
    });
    els.couponInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); els.couponBtn.click(); }
    });

    /* apps/quick-views que usam fetch/XHR pro carrinho */
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var p = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          var isAdd = url.indexOf('/cart/add') !== -1;
          p.then(function (r) { if (r.ok) refresh(isAdd); });
        }
      } catch (err) {}
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__acdUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__acdUrl && /\/cart\/(add|change|update|clear)(\.js)?/.test(xhr.__acdUrl)) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300) refresh(xhr.__acdUrl.indexOf('/cart/add') !== -1);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function init() {
    drawer = document.getElementById('acd');
    overlay = document.getElementById('acd-overlay');
    if (!drawer || !overlay) return;
    els = {
      close: document.getElementById('acd-close'),
      count: document.getElementById('acd-count'),
      items: document.getElementById('acd-items'),
      empty: document.getElementById('acd-empty'),
      foot: document.getElementById('acd-foot'),
      accs: document.getElementById('acd-accs'),
      subtotal: document.getElementById('acd-subtotal'),
      total: document.getElementById('acd-total'),
      shipbarText: document.getElementById('acd-shipbar-text'),
      shipbarFill: document.getElementById('acd-shipbar-fill'),
      recs: document.getElementById('acd-recs'),
      recsRow: document.getElementById('acd-recs-row'),
      note: document.getElementById('acd-note'),
      noteStatus: document.getElementById('acd-note-status'),
      couponInput: document.getElementById('acd-coupon-input'),
      couponBtn: document.getElementById('acd-coupon-btn'),
      couponStatus: document.getElementById('acd-coupon-status'),
      discountRow: document.getElementById('acd-discount-row'),
      discountCode: document.getElementById('acd-discount-code'),
      discountValue: document.getElementById('acd-discount-value'),
      discountRemove: document.getElementById('acd-discount-remove')
    };
    bindEvents();
    /* nenhuma requisição no pageview: o carrinho só é buscado quando o drawer abre ou muda */
    window.AmbaCartDrawer = { open: function () { refresh(true); }, close: close, refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
